const host = 'http://sorongkota.ina-sdi.or.id';

export const config = {
  host: `${host}/`,
  api: `${host}/api`,
  wms: `${host}/geoserver/wms?`,
};
export default config;
